module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/free-outside-sg/mobile-e66ac00564281afec1679c0e3cfc8a60.png";